import { Form, FormProps } from "@/components/form";
import { Stack, Typography } from "@mui/material";
import { z } from "zod/v4";
import { getAllOrganizaciones } from "../../organizaciones/api/get-all-organizaciones";
import { getOrganizacion } from "../../organizaciones/api/get-organizacion";
import { useAuthContext } from "@/features/auth/contexts/auth-context";
import { Permiso } from "@/shared/types/permiso";

export const addUsuarioFormSchema = z.object({
    nombre: z.string().nonempty("Este campo es requerido"),
    numDocumento: z.string().nonempty("Este campo es requerido"),
    email: z.email(),
    password: z.string().min(6, { message: "La contraseña debe tener 6 o más carácteres" }),
    telefono: z.string(),
    direccion: z.string(),
    organizacionId: z.string().optional(),
    rol: z.string().optional(),
})

export default function AddUsuarioForm({
    form,
    ...props
}: FormProps<z.infer<typeof addUsuarioFormSchema>>) {
    const { hasPermisos } = useAuthContext();
    const canManageOrganizaciones = hasPermisos(Permiso.ManageOrganizaciones);
    const canManageUsuarios = hasPermisos(Permiso.ManageUsuarios);

    // Admin o RootAdmin pueden asignar roles
    const canAssignRoles = canManageUsuarios || canManageOrganizaciones;

    return <Form form={form} gap={3} {...props}>
        <Stack gap={2}>
            <Typography component={"h2"} variant="h6">Datos Obligatorios</Typography>
            <Form.TextField name="nombre" label="Nombre" />
            <Form.TextField name="numDocumento" label="N° Documento" />
            {canManageOrganizaciones && (
                <Form.ModelComboBox name="organizacionId" label="Organización" get={getOrganizacion} getAll={getAllOrganizaciones} />
            )}
            <Form.EmailField name="email" label="Email" />
            <Form.PasswordField name="password" label="Password" />
            {canAssignRoles && (
                <Form.Select name="rol" label="Rol">
                    <Form.Select.Option value="User">Usuario</Form.Select.Option>
                    <Form.Select.Option value="Admin">Admin</Form.Select.Option>
                </Form.Select>
            )}
        </Stack>

        <Stack gap={2}>
            <Typography component={"h2"} variant="h6">Datos Personales</Typography>
            <Form.TextField name="telefono" label="Teléfono" />
            <Form.TextField name="direccion" label="Dirección" />
        </Stack>

        <Form.SubmitButton>Guardar</Form.SubmitButton>
    </Form>
}